export type CriteriaStepDraftKey =
	| "groups"
	| "classifications"
	| "manifestations"
	| "domains"
	| "risks"
	| "recomendations";

const storagePrefix = "criteria-form-draft";

function getDraftKey(criteriaId: number, step: CriteriaStepDraftKey) {
	return `${storagePrefix}:${criteriaId}:${step}`;
}

export function getCriteriaStepDraft<T>(criteriaId: number, step: CriteriaStepDraftKey): T | null {
	if (typeof window === "undefined") {
		return null;
	}

	try {
		const draft = window.localStorage.getItem(getDraftKey(criteriaId, step));
		return draft ? JSON.parse(draft) as T : null;
	} catch {
		return null;
	}
}

export function setCriteriaStepDraft<T>(criteriaId: number, step: CriteriaStepDraftKey, draft: T) {
	if (typeof window === "undefined") {
		return;
	}

	try {
		window.localStorage.setItem(getDraftKey(criteriaId, step), JSON.stringify(draft));
	} catch {
		// localStorage may be unavailable in private mode or restricted environments.
	}
}

export function clearCriteriaStepDraft(criteriaId: number, step: CriteriaStepDraftKey) {
	if (typeof window === "undefined") {
		return;
	}

	try {
		window.localStorage.removeItem(getDraftKey(criteriaId, step));
	} catch {
		// localStorage may be unavailable in private mode or restricted environments.
	}
}

export function clearCriteriaDrafts(criteriaId: number) {
	const steps: CriteriaStepDraftKey[] = [
		"groups",
		"classifications",
		"manifestations",
		"domains",
		"risks",
		"recomendations",
	];

	steps.forEach((step) => clearCriteriaStepDraft(criteriaId, step));
}
